import { productSubCategoryApi } from "../../api";

const ProductSubCategoryService = {

  /**
   * Obtener subcategorías de una categoría.
   */
  getByCategory: async (
    categoryId: number
  ) => {
    const response =
      await productSubCategoryApi.fetchCustom(
        `/category/${categoryId}`
      );

    return response.data;
  },

  /**
   * Obtener subcategorías activas para dropdown.
   */
  getDropdown: async (
    categoryId: number
  ) => {
    const response =
      await productSubCategoryApi.fetchCustom(
        `/dropdown/category/${categoryId}`
      );

    return response.data;
  },

  /**
   * Buscar subcategorías por nombre.
   */
  findByName: async (
    name: string
  ) => {
    const response =
      await productSubCategoryApi.fetchCustom(
        `/search?name=${name}`
      );

    return response.data;
  },

  /**
   * Crear subcategoría.
   */
  save: async (
    data: object
  ) => {
    const response =
      await productSubCategoryApi.add(
        data
      );

    return response.data;
  },

  /**
   * Actualizar subcategoría.
   */
  update: async (
    id: number,
    data: object
  ) => {
    const response =
      await productSubCategoryApi.modify(
        id,
        data
      );

    return response.data;
  },

  /**
   * Activar / Desactivar.
   */
  deactivate: async (
    id: number
  ) => {
    const response =
      await productSubCategoryApi.patchCustom(
        `${id}/toggle-status`
      );

    return response.data;
  },
};

export default ProductSubCategoryService;